import React, { useState, useEffect } from 'react'
import {
  Form,
  Input,
  Button,
  List,
  Avatar,
  Typography,
  Tooltip,
  Popconfirm,
  Spin,
  Divider
} from 'antd'
import { EditOutlined, DeleteOutlined, UserOutlined } from '@ant-design/icons'
import moment from 'moment'
import get from 'lodash.get'
import openNotification from '../common/Notification/openNotification '
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import { listNote, noteAdd, noteDelete } from '../../services/projectRecommendservice'
import { hasPermission } from '../../config-func'
dayjs.extend(utc)
dayjs.extend(timezone)
const { Text } = Typography

const Note = ({ postId }) => {
  const permissions = JSON.parse(localStorage.getItem('permissions') || '[]') 
  const [form] = Form.useForm()
  const [comments, setComments] = useState([])
  const [editingId, setEditingId] = useState(null) // ID đang chỉnh sửa
  const [loading, setLoading] = useState(true)

  const fetchNoteAdd = async (values) => {
    try {

      const body = {
        ...values,
        target_type: "AuctionPrice",
        target_id: postId
      }
      const res = await noteAdd(body)
      if (res?.data?.note) {
        openNotification('success', res?.message || 'Thành công')
        getListNote()
      }
    } catch (err) {
      const errors = get(err, 'response.data.message', [])
      // Xử lý lỗi nếu là mảng
      const errorMessages = Array.isArray(errors)
        ? errors.map((error) => error.message).join('\n')
        : errors // Nếu không phải mảng, lấy trực tiếp

      openNotification('error', errorMessages || 'Đã có lỗi xảy ra')
    } finally {
    }
  }
  const fetchNoteUpdate = async (values) => {
    try {

      const body = {
        ...values
      }
      const res = await noteUpdate(body, editingId)
      if (res?.message == 'Thay đổi thành công!') {
        openNotification('success', res?.message || 'Thành công')
        getListNote()
      }
    } catch (err) {
      const errors = get(err, 'response.data.message', [])
      // Xử lý lỗi nếu là mảng
      const errorMessages = Array.isArray(errors)
        ? errors.map((error) => error.message).join('\n')
        : errors // Nếu không phải mảng, lấy trực tiếp

      openNotification('error', errorMessages || 'Đã có lỗi xảy ra')
    } finally {
    }
  }

  // Danh sách note
  const getListNote = async () => {
    setLoading(true)
    const params = {
      target_id: postId,
      target_type: 'AuctionPrice'
    }
    try {
      const res = await listNote(params)
      if (res?.data) {
        setComments(res?.data?.list)
      }
    } catch (err) {
      openNotification('error', err?.response?.data?.message || 'Đã có lỗi xảy ra')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (postId) {
      getListNote()
    }
  }, [])

  // Thêm hoặc cập nhật comment
  const handleSubmit = (values) => {
    if (editingId !== null) {
      setEditingId(null)
      fetchNoteUpdate(values)
    } else {
      fetchNoteAdd(values)
    }

    form.resetFields()
  }

  // Xóa comment
  const handleDelete = async (id) => {
    const body = {
      ids: [id]
    }

    try {
      const res = await noteDelete(body, id)
      if (res?.message == 'Xóa thành công!') {
        openNotification('success', res.message || 'Thành công')
        getListNote()
      } else {
        openNotification('error', 'Đã có lỗi xảy ra')
      }
    } catch (err) {
      openNotification('error', 'Đã có lỗi xảy ra')
    } finally {
      setLoading(false)
    }
  }
  // Bắt đầu chỉnh sửa
  const handleEdit = (comment) => {
    setEditingId(comment.id)
    form.setFieldsValue({ note: comment.note })
  }

  return (
    <div style={{ maxWidth: '100%', margin: 'auto', padding: '0px 8px' }}>
      <Divider>Danh sách note</Divider>

      {/* Form nhập bình luận */}
      {hasPermission('P49.4', permissions) && (
        <Form form={form} onFinish={handleSubmit}>
        <Form.Item
          name="note"
          rules={[{ required: true, message: 'Nhập bình luận!' }]}
        >
          <Input.TextArea rows={2} placeholder="Viết bình luận..." />
        </Form.Item>
        <Button type="primary" htmlType="submit">
          {editingId !== null ? 'Cập nhật' : 'Thêm Note'}
        </Button>
      </Form>
      )}
      

      {/* Danh sách bình luận */}
      {loading ? (
        <Spin tip="Đang tải bình luận..." />
      ) : (
        <div style={{ maxHeight: 300, overflow: 'auto', marginTop: 20 }}>
          <List
            dataSource={comments}
            renderItem={(item) => (
              <List.Item
                actions={[
                  // <EditOutlined key="edit" onClick={() => handleEdit(item)} />,
                  hasPermission('P49.4', permissions) && (
                    <Popconfirm
                    title="Xóa bình luận?"
                    onConfirm={() => handleDelete(item.id)}
                  >
                    <DeleteOutlined key="delete" style={{ color: 'red' }} />
                  </Popconfirm>
                  )
                  
                ]}
              >
                <List.Item.Meta
                  avatar={<Avatar icon={<UserOutlined />} />}
                  title={
                    <Text strong>
                      {item.user_created}
                      {/* <Tooltip
                      title={moment(item.updated_at).format('YYYY-MM-DD HH:mm')}
                    > */}
                      <Text type="secondary" style={{ marginLeft: 10 }}>
                      {dayjs(item.created_at)
  .tz('Asia/Ho_Chi_Minh')
  .add(7, 'hour')
  .format('DD/MM/YYYY HH:mm:ss')}
                        {/* {item.updated_at} */}
                      </Text>
                      {/* </Tooltip> */}
                    </Text>
                  }
                  description={item.note}
                />
              </List.Item>
            )}
          />
        </div>
      )}
    </div>
  )
}

export default Note
